export default __webpack_public_path__ + "static/media/WillAndRachelsWedding.9c39ba44.PNG";